import { cubeApiUrl } from '~/constants/environment';

// Base URL of the TDC cube server.
export const TDC_API_BASE =
  process.env.CVNA_APIK_BASE_URL + '/newcar/testdrivecentercube';

// Routes to the standalone cube API when the `useCubeLegacyUrl` config is on.
export const getTdcApiBase = (useCubeLegacyUrl: boolean) =>
  useCubeLegacyUrl ? cubeApiUrl : TDC_API_BASE;
